var _path, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLedDivision(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8E8E8E",
    d: "M0 16.281h45.587v6.512H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.793,
    cy: 4.884,
    r: 4.884,
    fill: "#8E8E8E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.793,
    cy: 34.189,
    r: 4.884,
    fill: "#8E8E8E"
  })));
}
export default SvgLedDivision;